import {
  SET_FACILITYID,
  DELETE_FACILITYID,
  GET_FACILITY_SUCCESS
} from "./actions";

const initState = { id: 1, data: [] };

const facility = (state = initState, action) => {
  switch (action.type) {
    case SET_FACILITYID:
      return {
        ...state,
        ...action.id
      };
    case DELETE_FACILITYID:
      return {};
    case GET_FACILITY_SUCCESS:
      return {
        ...state,
        data: action.data
      };
    default:
      return state;
  }
};

export default facility;



// WEBPACK FOOTER //
// ./src/redux/facility/reducer.js